import { http } from "config/http";
import { http92 } from "config/http92";

export const audio_extraction = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http92.post(`audio`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

// Sentiments
export const voice_interaction_sentiment = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post(`audio_sentiment`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}
export const get_voice_interaction_sentiment = async (body: any) => {
    try {
        const res: any = await http.get(`get_audio_sentiments?audio_id=${body}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}


// black listed words
// black listed words
export const get_all_black_listed_word = async () => {
    try {
        const res: any = await http.get(`get_all_black_listed_word?client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}
export const black_listed_word = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post(`black_listed_word`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const delete_black_listed_words = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.delete(`delete_black_listed_words`, { data: destinationObject });
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const get_black_listed_word_by_id = async (body: any) => {

    try {
        const res: any = await http.get(`get_specific_black_listed_word?client_env=${localStorage.getItem("clientName")}&object_id=${body}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const update_black_listed_word = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.put(`update_black_listed_words`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

// Emotions
export const voice_interaction_emotions = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post(`emotions`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}
export const get_voice_interaction_emotions = async (body: any) => {
    try {
        const res: any = await http.get(`get_emotions?emotion_id=${body}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

// Hisotry
export const get_audio_history = async (fromDate: any, toDate: any, emotions: any, blackListed: string | undefined, selling: string | undefined) => {
    try {
        const res: any = await http.get(`audio_history?from_date=${fromDate}&user_name=${localStorage.getItem("username")}&to_date=${toDate}&emotions=${emotions}&is_black_list_word=${blackListed}&is_selling=${selling}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const get_audio_history_by_id = async (body: any) => {
    try {
        const res: any = await http.get(`audio_extraction_by_id?audio_id=${body}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const get_emotions_from_sentiment = async () => {
    try {
        const res: any = await http.get(`get_emotions_from_sentiment?client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}